import React from 'react';

import TextWrapper from '../text-wrapper';
import NotificationRowCtrl from '../notification-row';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
interface NotificationMerchOrderProps {
  className?: string;
  isRead: boolean;
  timestamp: string;
  imgSrc: string;
  items: {
    itemName: string;
    quantity: number;
  }[];
  amount: number;
  id: string;
  clearNotification: (id) => void;
}
export const NotificationMerchOrder = (props: NotificationMerchOrderProps) => {
  return (
    <NotificationRowCtrl
      className={props?.className}
      isRead={props?.isRead}
      timestamp={props?.timestamp}
      id={props.id}
      clearNotification={(id) => props.clearNotification(id)}
    >
      <TextWrapper
        justifyContent="flex-start"
        alignItems="baseline"
        flexDirection="row"
        isRead={props.isRead}
      >
        <Flex flexDirection="column">
          <div>
            <Typography>Congrats! A fan just bought your merch:</Typography>
          </div>
          <div>
            <ul>
              {props.items?.map((item) => (
                <li>
                  <Typography>
                    {item.itemName}
                    {'  '}({item.quantity})
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        </Flex>
        <Typography>
          <b>{`$${parseFloat(props?.amount.toString()).toFixed(2)}`}</b> will be
          added to your wallet 14 days after your fan receives their purchase
          (1-2 weeks from now).
        </Typography>
      </TextWrapper>
    </NotificationRowCtrl>
  );
};
